import {SearchOutlined} from '@ant-design/icons';
import {Flex, Divider, Input, Button} from 'antd';
import Title from 'antd/es/typography/Title';
import React, {useEffect, useState} from 'react';

import PageContent from '../../components/PageContent/PageContent';
import {platformEduArray} from '../../utils/platformEduArray';

import ClipList from './ClipList';

const PlatformEducation: React.FC = () => {
  const [selectedValue, setSelectedValue] = useState('allCategories');
  const [expandedCardKey, setExpandedCardKey] = useState('home');
  const [searchResults, setSearchResults] = useState<any[]>([]);

  const [isVideoPlayground, setIsVideoPlayground] = useState<any>(false);

  const [searchQuery, setSearchQuery] = useState('');

  useEffect(() => {
    if (isVideoPlayground) {
      setIsVideoPlayground(
        platformEduArray?.find((item) => item?.key === selectedValue)
      );
    }
  }, [selectedValue]);

  useEffect(() => {
    const query = searchQuery.toLowerCase();

    if (query) {
      if (isVideoPlayground) {
        const videosInCurrentModule = isVideoPlayground.videoData.filter(
          (video: any) => video.subTitle.toLowerCase().includes(query)
        );
        if (videosInCurrentModule.length > 0) {
          setIsVideoPlayground({
            ...isVideoPlayground,
            videoData: videosInCurrentModule
          });
        }
      }
      const videosInOtherModules = platformEduArray
        .flatMap((module) =>
          module.videoData.map((video: any) => ({
            ...video,
            moduleTitle: module.title,
            moduleKey: module.key
          }))
        )
        .filter(
          (video) =>
            video.subTitle.toLowerCase().includes(query) &&
            (!isVideoPlayground || video.moduleKey !== isVideoPlayground.key)
        );

      setSearchResults(videosInOtherModules);
    } else {
      if (isVideoPlayground) {
        const originalCategory = platformEduArray.find(
          (item) => item.key === isVideoPlayground.key
        );
        setIsVideoPlayground(originalCategory);
      }
      setSearchResults([]);
    }
  }, [searchQuery]);

  return (
    <PageContent>
      <Flex vertical className="platFormEducation">
        <Flex align="center" justify="space-between">
          <Title level={4} className="mainHeader">
            <Flex vertical={false} align="center" justify="center" gap={10}>
              <div>
                {isVideoPlayground ? 'Learning Hub' : 'Module Demo Library'}
              </div>
            </Flex>
          </Title>
          <Flex gap={10}>
            <Input
              placeholder="Search"
              suffix={<SearchOutlined />}
              style={{width: '200px'}}
              allowClear
              onChange={(e) => {
                setSearchQuery(e.target.value);
              }}
            />
          </Flex>
        </Flex>
        <Divider />
        <Flex vertical>
          <Flex
            className={`cardsContainer ${isVideoPlayground ? 'withClips' : ''}`}
            gap={16}
          >
            {platformEduArray?.map((item) => {
              const isExpanded = expandedCardKey === item?.key;
              const collapsedCount = platformEduArray.length - 1;

              return (
                <Flex
                  key={item?.key}
                  className={`categoryCard ${
                    isExpanded ? 'expanded' : 'collapsed'
                  }`}
                  style={{
                    width: isExpanded ? '60%' : `calc(40% / ${collapsedCount})`,
                    backgroundImage: isExpanded
                      ? `
    linear-gradient(
      180deg,
      rgba(0, 0, 0, 0.00) 0%,
      rgba(0, 0, 0, 0.50) 63.64%
    ),
    url(${item?.icon}),
    linear-gradient(105deg, #435B37 0%, #719A5D 100%)
  `
                      : `
    linear-gradient(
      0deg,
      rgba(0, 0, 0, 0.60) 0%,
      rgba(0, 0, 0, 0.60) 100%
    ),
    url(${item?.icon}),
    linear-gradient(105deg, #435B37 0%, #719A5D 100%)
  `,

                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    alignItems: isVideoPlayground ? 'center' : 'flex-end'
                  }}
                  onClick={(e) => {
                    if (!isExpanded) {
                      setExpandedCardKey(item?.key);
                    }

                    if (isVideoPlayground) {
                      e.stopPropagation();
                      setIsVideoPlayground(item);
                      setSelectedValue(item?.key);
                    }
                  }}
                >
                  <Flex vertical className="content" gap={isExpanded ? 15 : 0}>
                    <div
                      className={`${
                        isVideoPlayground ? 'shortTitle' : 'title'
                      }`}
                    >
                      {isVideoPlayground && !isExpanded
                        ? item?.shortTitle
                        : item?.title}
                    </div>
                    {!isVideoPlayground && (
                      <>
                        <div className="description">{item?.description}</div>
                        <Button
                          className="viewMore"
                          onClick={(e) => {
                            e.stopPropagation();
                            setIsVideoPlayground(item);
                            setSelectedValue(item?.key);
                          }}
                        >
                          View More
                        </Button>
                      </>
                    )}
                  </Flex>
                </Flex>
              );
            })}
          </Flex>
          {searchQuery && (
            <ClipList
              videos={searchResults}
              videoPageTitle="Search Results"
              showNoResultsMessage={true}
            />
          )}

          {isVideoPlayground && (
            <ClipList
              videos={isVideoPlayground.videoData}
              videoPageTitle={isVideoPlayground.videoPageTitle}
              videoPageDescription={isVideoPlayground.videoPageDescription}
            />
          )}
        </Flex>
      </Flex>
    </PageContent>
  );
};

export default PlatformEducation;
